<div class="wrapper">
  <mat-icon class="material-icons-outlined huge-icon" fontIcon="lock"></mat-icon>
  <span class="label">{{ 'UNAUTHORIZED' | translate }}</span>
</div>

